import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

const useSlugUrlRedirect = (isServer, initialProductId, masterProduct) => {
    const location = useLocation()

    const {shouldRedirect, redirectUrl} = useMemo(() => {
        if (!isServer || masterProduct?.slugUrl === undefined || masterProduct?.slugUrl === '')
            return {shouldRedirect: false}
        const slugUrl = new URL(
            masterProduct?.slugUrl.replace('/s/', '/'),
            // we only use pathname, so it doesn't matter what the origin is
            'https://www.stokke.com'
        )
        // location decodes unicode characters, so we need to encode them to compare with slugUrl
        const locationUrl = new URL(
            location.pathname,
            // we only use pathname, so it doesn't matter what the origin is
            'https://www.stokke.com'
        )

        const shouldRedirect =
            [locationUrl.pathname, slugUrl.pathname].every((url) =>
                url.includes(`${initialProductId}.html`)
            ) && !slugUrl.pathname.includes(locationUrl.pathname)

        return {
            shouldRedirect,
            redirectUrl: slugUrl.pathname + location.search
        }
    }, [initialProductId, location?.pathname, location.search, masterProduct?.slugUrl, isServer])

    if (shouldRedirect) {
        return redirectUrl
    }
}

export default useSlugUrlRedirect
